class RatingHandler {
    constructor(baseURL, basicUsername, basicPassword) {
        this.baseURL = baseURL+"/ratings";
        this.basicUsername = basicUsername;
        this.basicPassword = basicPassword;
    }

    getAuthorizationHeader() {
        const credentials = `${this.basicUsername}:${this.basicPassword}`;
        const base64Credentials = btoa(credentials);
        return {
            "Content-Type": "application/json",
            "Authorization": `Basic ${base64Credentials}`,
            Accepts: "application/json",
        };
    }

    async getAllRatings() {
        try {
            const response = await fetch(`${this.baseURL}/getAllRatings/`, {
                method: "GET",
                headers: this.getAuthorizationHeader(),
            });
            const json = await response.json();
            if (response.ok) {
                return json;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
        }
    }

    async getAllRatingsByProduktId(id) {
        try {
            console.log(`${this.baseURL}/getAllRatingsByProduktId/${id}`);            
            const response = await fetch(`${this.baseURL}/getAllRatingsByProduktId/${id}`, {
                method: "GET",
                headers: this.getAuthorizationHeader(),
            });
            const json = await response.json();
            if (response.ok) {
                console.log(response);
                return json;
            }

        } catch (error) {
            console.log("Backend not reachable", error);
        }
    }

    async getAllEnabledRatingsByProduktId(id) {
        try {
            const response = await fetch(`${this.baseURL}/getAllEnabledRatingsByProduktId/${id}`, {
                method: "GET",
                headers: this.getAuthorizationHeader(),
            });
            const json = await response.json();
            if (response.ok) {
                return json;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
        }
    }

    async createNewRating(ratingData) {
        try {
            const response = await fetch(`${this.baseURL}/createNewRating/`, {
                method: "POST",
                headers: this.getAuthorizationHeader(),
                body: JSON.stringify(ratingData),
            });
            const json = await response.json();
            if (response.ok) {
                return json;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
        }
    }

    async updateRating(id, updatedData) {
        try {
            const response = await fetch(`${this.baseURL}/updateRating/${id}`, {
                method: "PATCH",
                headers: this.getAuthorizationHeader(),
                body: JSON.stringify(updatedData),
            });
            const json = await response.json();
            if (response.ok) {
                return json;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
        }
    }

    async deleteRating(id) {
        try {
            const response = await fetch(`${this.baseURL}/deleteRating/${id}`, {
                method: "DELETE",
                headers: this.getAuthorizationHeader(),
            });
            const json = await response.json();
            if (response.ok) {
                return json;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
        }
    }
}

export default RatingHandler;